// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal__preview-evidence[data-v-34e6b802]  .modal-body{height:100dvh;overflow-y:auto}", ""]);
// Exports
module.exports = exports;
